<template>
    <div class="card rounded-lg position-relative" ref="root">
        <div class="card-header bg-transparent p-3">
            <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center gap-x-1">
                    <img width="40" height="40" class="rounded-circle"
                         :src="post.user.profile_picture?.full_url || urlGenerator('/images/avatar-demo.jpg')"
                         alt="">
                    <div>
                        <a :href="urlGenerator('/profile/' + post.user.uuid)" target="_blank">{{ post.user.full_name }}</a>
                        <div><small class="text-muted">{{ dateTimeToLocalWithFormat(post.created_at) }}</small></div>
                    </div>
                </div>
                <div v-if="post.user.id === user.id">
                    <div class="dropdown options-dropdown d-inline-block">
                        <button type="button" data-toggle="dropdown"
                                title="Actions" class="btn-option btn"
                                aria-expanded="false">
                            <app-icon name="more-vertical"/>
                        </button>
                        <div class="dropdown-menu dropdown-menu-right py-2 mt-1" style="">
<!--                            <a href="#" class="dropdown-item px-4 py-2">Menu 1</a>-->
                            <button v-if="post.user.id === user.id" @click="edit" class="dropdown-item px-4 text-primary py-2">
                                {{ $t('edit') }}</button>
                            <button v-if="post.user.id === user.id" @click="wannaDel = true" class="dropdown-item px-4 text-danger py-2">{{ $t('delete') }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-body p-3">
            <div v-html="sanitize(post.body)"></div>
            <div class="mt-4" v-if="post.attachments.length">
                <gallery :galleryID="`gallery-id-${post.id}`" :images="post.attachments.map(item => item.full_url)"/>
            </div>
        </div>
        <div class="card-footer p-0 bg-transparent">
            <!-- reaction and comments count -->
            <div class="px-3 py-2 border-bottom">
                <div class="d-flex align-items-center justify-content-between">
                    <div>
                        <div class="d-flex align-items-center gap-x-1">
                            <button class="reaction rounded-circle" style="width: 30px; height: 30px;" :class="reacted ? 'text-primary' : ''"
                                    @click="reaction"><app-icon :size="16" name="thumbs-up" />
                            </button>
                            <div>{{ reactions_count }}</div>
                        </div>
                    </div>
                    <div>
                        <button @click="commentExpand" class="reaction rounded-pill" style="padding: 3px 15px;">
                            <small>
                                {{ comments_count }}
                                {{ $t('comments') }}
                            </small>
                        </button>
                    </div>
                </div>
            </div>
            <!-- comment expanded -->
            <div v-if="isCommentExpanded">
                <!-- comments -->
                <div v-if="comments.data.length" class="d-flex flex-column">
                    <comment v-for="(comment, index) in comments.data" :comment="comment" :key="`root-${post.id}-comment-item-${comment.id}`" @del="delComment" />
                </div>
                <!-- load more -->
                <div v-if="more_comment" class="d-flex justify-content-center position-relative" style="height: 50px;">
                    <app-overlay-loader v-if="loading"/>
                    <button v-else @click="getComment" class="btn btn-link p-0">{{ $t('more_comment') }}</button>
                </div>
                <!-- recent comments -->
                <div v-if="comments.recentData.length" class="d-flex flex-column">
                    <comment v-for="(comment, index) in comments.recentData" :comment="comment"
                             :key="`${post.id}-comment-recent-item-${index}`" @del="delComment" />
                </div>
                <!-- new comment -->
                <new-comment class="m-3" @submit="submitComment" :id="post.id" :submitting="submitting"/>
            </div>
        </div>
        <!-- post delete -->
        <confirm v-if="wannaDel" @cancel="wannaDel = false" @confirm="delPost" :loading="deletting" />
    </div>
</template>

<script>
import Gallery from "../others/Gallery/Gallery";
import {dateTimeToLocalWithFormat} from "../../../../helpers/DateTimeHelper";
import NewComment from "./NewComment";
import axios from 'axios'
import {POST_COMMENT, POSTS} from "../../../../config/ApiUrl";
import {urlGenerator} from "../../../../helpers/AxiosHelper";
import sanitize from "../../../../helpers/SanitizeHelper";
import Confirm from "../others/Confirm";

export default {
    components: {Gallery, NewComment, Confirm},
    props: ['post', 'recent'],
    data() {
        return {
            user: window.user,
            urlGenerator,
            sanitize,
            dateTimeToLocalWithFormat,
            postGallery: {
                like: ''
            },
            loading: false,
            deletting: false,
            isCommentExpanded: false,
            comments: {
                data: [],
                recentData: []
            },
            comment_options: {
                page: 1,
                per_page: 3
            },
            more_comment: true,
            submitting: false,
            comments_count: 0,
            reactions_count: 0,
            reacted: false,
            wannaDel: false
        }
    },
    methods: {
        reaction() {
            axios.post(urlGenerator(POSTS + '/' + this.post.id + '/react'), {reaction: '👍'}).then(res => {
                this.reacted = res.data.data.reacted
                this.reactions_count = res.data.data.reactions_count
            }).finally(() => {
            })
        },
        submitComment(event) {
            this.submitting = true
            axios.post(urlGenerator(POST_COMMENT + this.post.id + '/post-comments'), {comment: event.target.content.value}).then(res => {
                this.comments.recentData.push(res.data.comment)
                this.comments_count = Number(this.comments_count) + Number(1)
            }).catch(err => {})
            .finally(() => {
                this.submitting = false
            })
        },
        commentExpand() {
            if (!this.isCommentExpanded) {
                this.getComment()
            } else {
                this.comments.data = []
                this.comment_options.page = 1
                this.more_comment = true
            }
            this.isCommentExpanded = !this.isCommentExpanded
        },
        getComment(previous_data = false) {
            this.loading = true
            axios.get(urlGenerator(POST_COMMENT + this.post.id + '/post-comments') , {params: this.comment_options}).then((res) => {
                this.comments.data = [...this.comments.data, ...res.data.data]
                this.more_comment = this.comment_options.page !== res.data.last_page
                this.comment_options.page += 1
                // if(res.data.data.length < this.comment_options.per_page) this.more_comment = false
            }).finally(() => {
                setTimeout(() => {
                    this.loading = false
                }, 500)
            })
        },
        delPost(){
            this.deletting = true
            this.$emit('del', this.post.id)
        },
        delComment(id) {
            this.comments.data = this.comments.data.filter(i => i.id !== id)
            this.comments.recentData = this.comments.recentData.filter(i => i.id !== id)
            this.comments_count = Number(this.comments_count) - Number(1)
        },
        edit(){
            this.$emit('edit', this.post.id)
        },
        recentStyle(){
            let root = this.$refs.root
            root.style.boxShadow = '0 0 8px 1px rgba(172,205,255,0.75)'
            root.style.transition = 'boxShadow 0.5s'
            root.style.border = '1px solid rgb(172,205,255)'
            setTimeout(function () {
                root.style.boxShadow = ''
                root.style.border = ''
            }, 5000)
        }
    },
    mounted() {
        this.comments_count = this.post.comments_count
        this.reactions_count = this.post.reactions_count
        this.reacted = this.post.reacted
        if (this.recent) {
            this.recentStyle()
        }
    },
    watch: {
        recent(n){
            if(n){
                this.recentStyle()
            }
        }
    }
}
</script>

<style scoped lang="scss">
.rounded-lg {
    border-radius: 15px !important;
    overflow: hidden;
}

.reaction {
    border: none;
    //border-radius: 5px;
    //padding: 3px 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    background-color: #0c546010;

    &:hover {
        background-color: #0c546030;
    }
}

</style>